import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { EntityType } from "@mapmycustomers/shared/enum";
import type { FiCatalogResponse } from "@mapmycustomers/shared/types/entity/fieldInsight";
import type Organization from "@mapmycustomers/shared/types/Organization";

import TextSearchResult from "@app/types/TextSearchResult";

export const searchEntityMentions = createAsyncAction(
  "@component/entityMentions/searchEntityMentions/request",
  "@component/entityMentions/searchEntityMentions/success",
  "@component/entityMentions/searchEntityMentions/failure"
)<{ query: string }, { results: TextSearchResult[] }, void>();

export const clearEntityMentionSearch = createAction(
  "@component/entityMentions/clearEntityMentionSearch"
)();

// Pre-flight a mention pill's read access via the saga (callApi) before the
// hook navigates; onAllowed/onDenied keep navigation + i18n in the hook.
export const checkEntityMentionAccess = createAction(
  "@component/entityMentions/checkEntityMentionAccess"
)<{
  entityId: number;
  entityType: EntityType;
  onAllowed: () => void;
  onDenied: () => void;
}>();

// The server resolves every mention type except charts, so a `@chart:<id>`
// marker needs its name looked up here before it can render as a pill. Kept
// out of the dashboard's Field Insights catalog because that one is fetched
// per scope, while a marker has to resolve on any surface, at any scope.
export const fetchMentionCharts = createAsyncAction(
  "@component/entityMentions/fetchMentionCharts/request",
  "@component/entityMentions/fetchMentionCharts/success",
  "@component/entityMentions/fetchMentionCharts/failure"
)<{ organizationId: Organization["id"] }, { charts: FiCatalogResponse[] }, void>();

// Opening a chart means routing into the Dashboard scene, which this component
// must not reach into — the scene's own saga picks this up and navigates.
export const openChartMention = createAction("@component/entityMentions/openChartMention")<{
  chartId: FiCatalogResponse["id"];
}>();

export type Actions = ActionType<
  | typeof checkEntityMentionAccess
  | typeof clearEntityMentionSearch
  | typeof fetchMentionCharts
  | typeof openChartMention
  | typeof searchEntityMentions
>;
